export default {
      id: "graph-espaceec-usage",
      viewBox: "0 0 268 164",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-espaceec",
      toString: function () {
        return this.url;
      }
    }